import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import useUser from '../../../services/hooks/useUser';
import './MainLayout.scss';
import Sidebar from '../../components/Sidebar';

const MainLayout: React.FC = () => {
  const { data: user } = useUser();
  const navigate = useNavigate();
  const { orgPath = '' } = useParams();

  useEffect(() => {
    if (user) {
      if (!orgPath && user?.orgs?.length !== 0) {
        navigate(`/${user.orgs[0].url}`);
      }
    }
  }, [user, orgPath, navigate]);

  return (
    <div className="main-layout">
      <Sidebar />
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
